import { render, staticRenderFns } from "./dates-section.vue?vue&type=template&id=34279054"
import script from "./dates-section.vue?vue&type=script&lang=js"
export * from "./dates-section.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports